var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkaliLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 20,
    viewBox: "0 0 73 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002807",
    clipPath: "url(#clip0_2280_5505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M3.52431 2.85765C2.56998 3.30685 1.86424 3.90213 1.4071 4.64449C0.950441 5.38734 0.72187 6.19877 0.72187 7.07976C0.72187 7.99405 0.90551 8.74088 1.27474 9.31977C1.64348 9.89964 2.12895 10.3603 2.73066 10.7026C3.33189 11.045 3.99709 11.3267 4.72676 11.5468C5.45692 11.7675 6.18268 11.9593 6.90454 12.1222C7.62639 12.2857 8.28768 12.477 8.88939 12.6977C9.4911 12.9178 9.97999 13.208 10.357 13.5667C10.7336 13.9255 10.9226 14.399 10.9226 14.9859C10.9226 15.4922 10.778 15.9454 10.4894 16.3444C10.2008 16.7449 9.75142 17.0589 9.1419 17.2875C8.53237 17.5155 7.73823 17.6298 6.76045 17.6298C5.68548 17.6298 4.65105 17.4425 3.65667 17.0668C2.6618 16.6917 1.84373 16.2186 1.20246 15.6467L0.312592 17.5563C0.986096 18.1928 1.90868 18.7106 3.07889 19.1106C4.24959 19.5106 5.47694 19.7103 6.76045 19.7103C8.23542 19.7103 9.45838 19.4862 10.4293 19.037C11.3993 18.5888 12.1172 17.9931 12.5822 17.2507C13.0476 16.5083 13.2801 15.7044 13.2801 14.8393C13.2801 13.9424 13.096 13.208 12.7272 12.6365C12.358 12.0651 11.8725 11.608 11.2713 11.2656C10.6696 10.9232 10.0039 10.646 9.27425 10.4333C8.54409 10.2216 7.81882 10.0298 7.09697 9.8584C6.37511 9.68697 5.71381 9.49517 5.1121 9.283C4.51088 9.07132 4.0215 8.78561 3.64495 8.42635C3.26741 8.06759 3.07889 7.5861 3.07889 6.98237C3.07889 6.47653 3.21907 6.01939 3.50039 5.61095C3.78073 5.20399 4.22566 4.87703 4.83567 4.63206C5.4447 4.38759 6.22273 4.26486 7.16925 4.26486C7.92285 4.26486 8.70087 4.37517 9.50282 4.59579C10.3048 4.81591 11.0667 5.1707 11.7885 5.66014L12.5822 3.70188C11.8765 3.21293 11.0427 2.83778 10.0806 2.57591C9.11796 2.31504 8.14702 2.18486 7.16925 2.18486C5.69379 2.18486 4.47816 2.40896 3.52431 2.85765Z",
    fill: "url(#paint0_linear_2280_5505)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M28.9421 2.38061L19.7998 11.9632V2.38061H17.3939V19.5145H19.7998V15.0807L22.8899 11.8927L29.327 19.5145H32.1421L24.4972 10.0979L31.685 2.38061H28.9421Z",
    fill: "url(#paint1_linear_2280_5505)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M39.6962 2.38061L32.0699 19.5145H34.5475L36.3981 15.2308H45.3529L47.2029 19.5145H49.729L42.0782 2.38061H39.6962ZM40.8752 4.86508L44.507 13.2725H37.2435L40.8752 4.86508Z",
    fill: "url(#paint2_linear_2280_5505)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M52.8322 2.38061V19.5145H64.3565V17.3848H55.2381V2.38061H52.8322Z",
    fill: "url(#paint3_linear_2280_5505)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M67.7245 19.5145H70.1304V2.38061H67.7245V19.5145Z",
    fill: "url(#paint4_linear_2280_5505)"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2280_5505",
    x1: 0.312513,
    y1: 10.9474,
    x2: 13.2801,
    y2: 10.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2280_5505",
    x1: 17.3938,
    y1: 10.9474,
    x2: 32.1419,
    y2: 10.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2280_5505",
    x1: 32.0697,
    y1: 10.9474,
    x2: 49.729,
    y2: 10.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2280_5505",
    x1: 52.8323,
    y1: 10.9474,
    x2: 64.3566,
    y2: 10.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2280_5505",
    x1: 67.7246,
    y1: 10.9474,
    x2: 70.1305,
    y2: 10.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DD0EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2280_5505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 20,
    fill: "white",
    transform: "translate(0.444458)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaliLogoText);
export default __webpack_public_path__ + "static/media/skali-logo-text.2e9eaf6a8118fc888026c00c7acd15f8.svg";
export { ForwardRef as ReactComponent };